import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import styles from "@/styles/article/return-policy.module.scss";
import { usePathname } from "next/navigation";
import ArticleTemplate from "@/components/article/ArticleTemplate";

export default function WarrantyPolicy() {
  const pathname = usePathname();
  const articleName = pathname.split("/").pop() || "";
  return (
    <>
      <Head>
        <title>
          Online Shopping New Zealand - Beauty & Health, Computers, Toys, -
          Deals & Discounts | BestDeals
        </title>
        <meta name="keywords" content=""></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout>
        <div className={`${styles["page-return-policy"]} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <ArticleTemplate articleName={articleName} />
        </div>
      </DefaultLayout>
    </>
  );
}
